import React from 'react';
import { Result, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

/**
 * 错误边界组件
 * 捕获子组件中的错误并显示友好的错误页面
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // 可以在这里记录错误到日志服务
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleReload = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <Result
                    status="error"
                    title="页面加载失败"
                    subTitle={
                        <div>
                            <p>抱歉，页面遇到了一些问题。</p>
                            {process.env.NODE_ENV === 'development' && (
                                <details style={{ marginTop: 16, textAlign: 'left' }}>
                                    <summary style={{ cursor: 'pointer', color: '#ff4d4f' }}>
                                        错误详情（仅开发环境可见）
                                    </summary>
                                    <pre style={{ 
                                        marginTop: 8, 
                                        padding: 8, 
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: 4,
                                        fontSize: 12
                                    }}>
                                        {this.state.error && this.state.error.toString()}
                                    </pre>
                                </details>
                            )}
                        </div>
                    }
                    extra={[
                        <Button 
                            type="primary" 
                            key="reload" 
                            icon={<ReloadOutlined />}
                            onClick={this.handleReload}
                        >
                            重新加载页面
                        </Button>,
                        <Button 
                            key="back"
                            onClick={() => window.history.back()}
                        >
                            返回上一页
                        </Button>
                    ]}
                />
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;

